/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Divider,
  Flex,
  Icon,
  Scrollbar,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { CheckSIcon } from '@tonic-one/react-icons';
import isEqual from 'lodash/isEqual';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EnableDisableStatus } from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import { FilterStatusArrType, usePolicyTabsStore } from './context';
import { useCheckStyle } from './style';
import { useActiveMenuStyle } from '@Policy/style';

const PolicyTabPanel = React.memo(({ loaded }: { loaded: boolean }) => {
  const allTabPanels = usePolicyTabsStore((s) => s.allPanelComponents);
  useWhyDidYouUpdate('PolicyTabPanel', { loaded });
  return (
    <TabPanel>
      {({ isSelected, index, getTabPanelProps }: any) => {
        if (Number.isInteger(index) && (isSelected || loaded)) {
          console.log('policy tab panel:', isSelected, index, loaded);
          // return the component when it is selected or is loaded before
          const PannelComponent = allTabPanels[index];
          return (
            <Box
              {...getTabPanelProps()}
              className="policy-tabPanel"
              px="3x"
              py="2x"
              width="100%"
            >
              <PannelComponent />
            </Box>
          );
        } else {
          return null;
        }
      }}
    </TabPanel>
  );
});
const PolicyTab = React.memo(
  ({
    status,
    filter,
  }: {
    status: EnableDisableStatus | null;
    filter: string;
  }) => {
    const { t } = useTranslation('policy');
    const [colorMode] = useColorMode();
    const [colorStyle] = useColorStyle({ colorMode });
    const activeMenuStyle = useActiveMenuStyle();
    useWhyDidYouUpdate('PolicyTab', { status, filter });
    return (
      <Tab
        width="270px"
        key={filter}
        position="relative"
        _selected={activeMenuStyle}
        // index={filter}
        // onClick={() => onTabClick(filter)}
      >
        <Text color={colorStyle.color.primary}>
          {t(`policy.filterName.${filter}`)}
        </Text>
        {status === null ? null : (
          <Box ml="auto">
            <CheckIcon status={!!status} />
          </Box>
        )}
      </Tab>
    );
  }
);
export const PolicyTabs = React.memo(
  (props: {
    allTabs: string[];
    tabStatusArr: FilterStatusArrType;
    activeTabIndex: number;
    onTabClick: (index: number) => void;
    [key: string]: any;
  }) => {
    const {
      allTabs,
      tabStatusArr,
      onTabClick,
      activeTabIndex,
      allTabPanelComponents,
    } = props;
    const [scrollTop, setScrollTop] = useState(0);

    const tabClicked = usePolicyTabsStore((s) => s.tabClicked, isEqual);
    const setAllPanelComponents = usePolicyTabsStore(
      (s) => s.setAllPanelComponents
    );
    const clickTab = usePolicyTabsStore((s) => s.clickTab);
    const clearTabClicked = usePolicyTabsStore((s) => s.clearTabClicked);

    useEffect(() => {
      setAllPanelComponents(allTabPanelComponents);
      clearTabClicked();
    }, []);

    useEffect(() => {
      clickTab(allTabs[activeTabIndex]);
      setScrollTop(0);
    }, [activeTabIndex]);

    useWhyDidYouUpdate('PolicyTabs', {
      allTabs,
      tabStatusArr,
      onTabClick,
      tabClicked,
      activeTabIndex,
    });

    return (
      <Flex flex={1}>
        <Tabs
          orientation="vertical"
          index={activeTabIndex}
          onChange={onTabClick}
          width="100%"
        >
          <TabList height="max-content" position="sticky" top={0}>
            {allTabs.map((filter, index) => (
              <PolicyTab
                filter={filter}
                key={filter}
                status={tabStatusArr[index]}
              />
            ))}
          </TabList>
          <Divider orientation="vertical" height="100%" />
          <Scrollbar
            scrollTop={scrollTop}
            onScroll={(e: any) => {
              setScrollTop(e.target.scrollTop);
            }}
            width="100%"
            height="100%"
            overflow="scroll"
          >
            <TabPanels width="100%" height="100%">
              {allTabs.map((filter) => {
                return (
                  <PolicyTabPanel
                    key={filter}
                    loaded={tabClicked.includes(filter)}
                  />
                );
              })}
            </TabPanels>
          </Scrollbar>
        </Tabs>
      </Flex>
    );
  }
);

function CheckIcon(props: { status: boolean }) {
  const { checked, unChecked } = useCheckStyle();
  if (props.status) {
    return <Icon as={CheckSIcon} {...checked} />;
  } else {
    return <Icon as={CheckSIcon} {...unChecked} />;
  }
}
